// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
 * The copy for the page a client lands on from their portal invitation e-mail
 * (frontend-15). The reader is a client, not an accountant and not a HeadOffice
 * user, so the vocabulary matches the rest of the portal: "your documents", "your
 * accountant", never "engagement", "tenant" or "portal user".
 */

export default {
    '$dir': 'ltr',

    'portals.clients.invitation.title': 'Your accountant has invited you',
    'portals.clients.invitation.explain': 'Accepting adds this invitation to the account you are signed in with. It can only be used once.',
    'portals.clients.invitation.signedInAs': 'You are signed in as {name}.',
    'portals.clients.invitation.accept': 'Accept invitation',
    'portals.clients.invitation.wrongAccount': 'Not you? Sign in with a different account',
    'portals.clients.invitation.working': 'Setting up your access…',

    'portals.clients.invitation.accepted': 'You are all set',
    'portals.clients.invitation.acceptedHelp': '{practice} can now send you what they need and share your paperwork here.',
    'portals.clients.invitation.continue': 'Go to your documents',
    'portals.clients.invitation.chooseOrganisation': 'Go to my organisations',
    'portals.clients.invitation.chooseOrganisationHelp': 'Choose {practice} from the list to open your documents.',

    'portals.clients.invitation.used': 'This link has already been used',
    'portals.clients.invitation.usedHelp': 'If you have already set your access up, open it from your list of organisations. If you have not, ask {practice} for a fresh invitation.',

    'portals.clients.invitation.refused': 'We could not set your access up',
    'portals.clients.invitation.refusedHelp': 'Get in touch with {practice} and they will put it right.',

    'portals.clients.invitation.failed': 'Something went wrong setting your access up.',
    'portals.clients.invitation.tryAgain': 'Try again',

    'portals.clients.invitation.yourAccountant': 'your accountant',
};
